import React from 'react';
import {
	Paper
} from '@mui/material';

function PaperWrapper({ children, sx = {} }) {
    const allSize = {
        height: '100%',
        width: '100%',
    };
    return (
        <Paper sx={{ ...allSize, ...sx }} elevation={5}>
            {children}
        </Paper>
    );
}

export default PaperWrapper;